import * as React from "react";

function AzureIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" {...props}>
      <defs>
        <linearGradient id="linear-gradient" x1="-52.379" y1="24.203" x2="-52.691" y2="24.819" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-color="#114a8b" />
          <stop offset="1" stop-color="#0669bc" />
        </linearGradient>
        <linearGradient id="linear-gradient-2" x1="-37.482" y1="24.489" x2="-37.534" y2="24.506" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-opacity="0.302" />
          <stop offset="0.071" stop-opacity="0.2" />
          <stop offset="0.321" stop-opacity="0.102" />
          <stop offset="0.623" stop-opacity="0.051" />
          <stop offset="1" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="linear-gradient-3" x1="-50.157" y1="24.183" x2="-49.831" y2="24.794" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-color="#3ccbf4" />
          <stop offset="1" stop-color="#2892df" />
        </linearGradient>
      </defs>
      <g id="Group_12393" data-name="Group 12393" transform="translate(-807 -572)">
        <rect id="Rectangle_4142" data-name="Rectangle 4142" width="40" height="40" rx="5" transform="translate(807 572)" fill="none" />
        <g id="icons8-azure" transform="translate(806.104 571)">
          <path
            id="Path_44006"
            data-name="Path 44006"
            d="M15.836,6h9.709L15.466,35.864A1.547,1.547,0,0,1,14,36.917H6.443A1.546,1.546,0,0,1,4.9,35.371a1.563,1.563,0,0,1,.081-.495L14.369,7.054A1.548,1.548,0,0,1,15.836,6Z"
            transform="translate(0 0)"
            fill="url(#linear-gradient)"
          />
          <path
            id="Path_44007"
            data-name="Path 44007"
            d="M31.414,29.324h-15.4a.713.713,0,0,0-.487,1.234l9.894,9.234a1.555,1.555,0,0,0,1.062.418H35.2Z"
            transform="translate(-1.469 -3.293)"
            fill="#0078d4"
          />
          <path
            id="Path_44008"
            data-name="Path 44008"
            d="M15.836,6a1.536,1.536,0,0,0-1.47,1.074L4.99,34.852a1.544,1.544,0,0,0,.932,1.974,1.563,1.563,0,0,0,.526.091H14.2a1.657,1.657,0,0,0,1.272-1.081l1.87-5.51,6.678,6.229a1.577,1.577,0,0,0,.995.362H33.7L29.89,26.031l-11.106,0L25.581,6Z"
            transform="translate(0 0)"
            fill="url(#linear-gradient-2)"
          />
          <path
            id="Path_44009"
            data-name="Path 44009"
            d="M30.054,7.052A1.546,1.546,0,0,0,28.589,6H17.768a1.545,1.545,0,0,1,1.464,1.051l9.391,27.825a1.546,1.546,0,0,1-.97,1.959,1.509,1.509,0,0,1-.494.082H37.981a1.546,1.546,0,0,0,1.546-1.547,1.531,1.531,0,0,0-.082-.494Z"
            transform="translate(-1.817 0)"
            fill="url(#linear-gradient-3)"
          />
        </g>
      </g>
    </svg>
  );
}

export default AzureIcon;
